import { format } from "date-fns";
import defaultStrategy from "./default.js";

function hasTourDate(site) {
  return /^https:\/\/www\.recreation\.gov\/(?:ticket|timed-entry)\/\d+\/ticket\/\d+$/.test(
    site?.reserveUrl ?? "",
  );
}

export default {
  ...defaultStrategy,
  buildBookingUrl({ site, arrivalDate }) {
    if (!hasTourDate(site) || !arrivalDate) return site.reserveUrl;
    const url = new URL(site.reserveUrl);
    url.searchParams.set("date", format(arrivalDate, "yyyy-MM-dd"));
    return url.toString();
  },
  buildPreviewUrl(site) {
    if (!hasTourDate(site)) return site.reserveUrl;
    const url = new URL(site.reserveUrl);
    const [, type, facilityId] = url.pathname.split("/");
    url.pathname =
      type === "ticket"
        ? `/ticket/facility/${facilityId}`
        : `/timed-entry/${facilityId}`;
    return url.toString();
  },
  describeBookingInputs({ site } = {}) {
    const description = defaultStrategy.describeBookingInputs();
    if (hasTourDate(site)) {
      description.inputs.arrivalDate = {
        status: "optional",
        notes:
          "The tour page accepts date=YYYY-MM-DD; departure time and quantity are selected on that page.",
      };
    }
    return description;
  },
};
